import React from "react";
import DropdownComponent from "../components/DropdownComponent";
import ListItemButtonStack from "../components/IconSingleChoice";
import CheckboxComponent from "../components/CheckboxComponent";
import AmountFieldComponent from "../components/AmountFieldComponent";
import TextFieldComponent from "../components/TextfieldComponent";
import RadioComponent from "../components/RadioButtonComponent";
import NumberFieldComponent from "../components/NumberFieldComponent";
import PercentageComponent from "../components/PercentageComponent";
import CityAutoComplete from "../components/CityAutoComplete";
import AddressAutoComplete from "../components/AddressAutoComplete";
import TextSingleChoice from "../components/TextSingleChoice";
import DateFieldComponent from "../components/DateFieldComponent";

export const renderQuestion = (question, handleChange, formData, errors) => {
    const { key, type, options, label } = question;
    const lang = localStorage.getItem("language") === "Spanish" ? "Spanish" : "English";

    const getValue = (key) => {
        return formData[key] ? formData[key] : '';
    };

    const error = errors[key];
    const helperText = error || '';
    const handleCitySelection = (cityData, city) => {
        handleChange('city', city);
        handleChange('state', cityData.state);
        handleChange('county', cityData.county);
        handleChange('zipCode', cityData.zip);
    };
    const handleAddressSelection = (addressData, address) => {
        handleChange('address', address);
        handleChange('city', addressData.city);
        handleChange('state', addressData.state);
        handleChange('county', addressData.county);
        handleChange('zipCode', addressData.zip);
    };

    switch (type) {
        case 'dropdown':
            return <DropdownComponent value={getValue(key)} onChange={handleChange} options={options} questionKey={key} disabled={false} />;
        case 'radio':
            return <RadioComponent value={getValue(key)} onChange={handleChange} options={options} questionKey={key} />;
        case 'textSingleChoice':
            return <TextSingleChoice value={getValue(key)} onChange={handleChange} options={options} questionKey={key} />;
        case 'iconSingleChoice':
            return <ListItemButtonStack questionKey={key} value={getValue(key)} options={options} onChange={handleChange} />;
        case 'multipleChoice':
            return <CheckboxComponent questionKey={key} value={getValue(key)} options={options} onChange={handleChange} />;
        case 'amount':
            return <AmountFieldComponent questionKey={key} value={getValue(key)} onChange={handleChange} label={label} lang={lang} />;
        case 'text':
            const maxLength = (key === 'firstName' || key === 'lastName') ? 75 : undefined;
            return <TextFieldComponent questionKey={key} value={getValue(key)} onChange={handleChange} error={!!error} helperText={helperText} maxLength={maxLength} label={label} lang={lang} />;
        case 'number':
            return <NumberFieldComponent questionKey={key} value={getValue(key)} onChange={handleChange} error={!!error} helperText={helperText} label={label} lang={lang} />;
        case 'percentage':
            return <PercentageComponent questionKey={key} value={getValue(key)} onChange={handleChange} label={label} lang={lang} />;
        case 'cityAutoComplete':
            // For purchase form: if user selected "I'm under contract", show address search instead
            const isUnderContract = formData.daysToPurchase === "I'm under contract";
            if (isUnderContract) {
                // Dynamic label based on language: "Please enter your address" or "Ingrese su dirección"
                const addressLabel = lang === "Spanish" ? "Ingrese su dirección" : "Please enter your Property Address";
                return <AddressAutoComplete key={`address-${formData.daysToPurchase || 'default'}`} formData={formData} onSelectionChange={handleAddressSelection} label={addressLabel} lang={lang} />;
            }
            // Dynamic label based on language: "Please enter your city" or "Ingrese su ciudad"
            const cityLabel = lang === "Spanish" ? "Ingrese su ciudad" : "Please enter your city";
            return <CityAutoComplete key={`city-${formData.daysToPurchase || 'default'}`} formData={formData} onSelectionChange={handleCitySelection} label={cityLabel} lang={lang} />;
        case 'addressAutoComplete':
            return <AddressAutoComplete formData={formData} onSelectionChange={handleAddressSelection} label={label} lang={lang} />;
        case 'date':
            return <DateFieldComponent questionKey={key} value={getValue(key)} onChange={handleChange} label={label} lang={lang} />
        default:
            return null;
    }
};